import { useTheme } from '../../contexts/ThemeContext'

const OPTIONS = [
  { key: 'light',  icon: '☀', label: 'Light' },
  { key: 'dark',   icon: '🌙', label: 'Dark' },
  { key: 'system', icon: '💻', label: 'System' },
]

export default function ThemeToggle({ compact = false }) {
  const { preference, setTheme } = useTheme()

  if (compact) {
    return (
      <button
        onClick={() => {
          const order = ['dark', 'light', 'system']
          const next = order[(order.indexOf(preference) + 1) % order.length]
          setTheme(next)
        }}
        className="btn-ghost text-xs flex items-center gap-1.5"
        title={`Theme: ${preference}`}
      >
        {OPTIONS.find(o => o.key === preference)?.icon || '🌙'}
      </button>
    )
  }

  return (
    <div className="flex rounded-xl overflow-hidden" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
      {OPTIONS.map(opt => (
        <button key={opt.key}
          onClick={() => setTheme(opt.key)}
          className={`px-3 py-1.5 text-[11px] font-semibold flex items-center gap-1.5 transition-all ${
            preference === opt.key
              ? 'bg-[var(--color-primary)] text-white'
              : 'text-[var(--text-dim)] hover:text-white hover:bg-white/4'
          }`}>
          <span>{opt.icon}</span>
          <span>{opt.label}</span>
        </button>
      ))}
    </div>
  )
}
